import React from 'react'
import { ExecuteOperationOnPipe } from '@morningtrain/react-resources'
import Permissions from 'services/Permissions'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import * as UI from 'ui'
import { Button } from 'ui'
import { Translation } from '@morningtrain/react-translations'
import { Can } from '@morningtrain/react-auth'
import { AddRouteToPayloadOnPipe, NavigateOnPipe } from '@morningtrain/react-navigation'

export default function StartCheckupButton () {
  return (
    <Can permission={Permissions.CLEANING_CHECKUPS_MANAGE}>
      <Pipeline>
        <TriggerPipelineOnClick>
          <Button type='button'>
            <UI.WithIcon size={4} placement='right' icon={<UI.Icons.Plus/>}>
              <Translation name='actions.create_checkup'/>
            </UI.WithIcon>
          </Button>
        </TriggerPipelineOnClick>
        <ExecuteOperationOnPipe
          namespace='api'
          resourceName='cleaning.checkup'
          operationName='start_checkup'
        />
        <AddRouteToPayloadOnPipe/>
        <NavigateOnPipe
          route='app.cleaning.perform_checkup'
          routeParameters={{
            cleaning_checkup: 'payload:responses.start_checkup.id',
          }}
        />
      </Pipeline>
    </Can>
  )
}
